import { FormlyForm, FormlyFormBuilder, FormlyConfig, FormlyFieldConfig } from '@ngx-formly/core';

import { Component, Attribute, Optional, NgZone } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';

@Component({
  selector: 'sn-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
  inputs: ['form', 'model', 'fields', 'options'],
  // eslint-disable-next-line @angular-eslint/no-outputs-metadata-property
  outputs: ['modelChange'],
})
export class SnFormComponent extends FormlyForm {
  constructor(
    formlyBuilder: FormlyFormBuilder,
    formlyConfig: FormlyConfig,
    ngZone: NgZone,
    @Attribute('immutable') immutable: any,
    @Optional() parentFormGroup: FormGroupDirective,
  ) {
    super(formlyBuilder, formlyConfig, ngZone, immutable, parentFormGroup);
  }

  public trackField(index: number, item: FormlyFieldConfig): any {
    return item.key;
  }
}
